/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
    <div>
      <Navigation :name="userName" @logout="logout" />
      <MainToolbar />
      <ScrollingBanner v-if='showGlobalBanner' :message="globalBannerMsg" :scrollSpeed="'10'" />
      <ScrollingBanner v-if='showBanner' :message="bannerMsg" />

    <v-content class="content-style">
      <Banner @toggleBanner="toggleBanner" :isBannerOpen="computeBannerShow">
        <template slot="header"> {{ $t('Subscription Alert') }}!! </template>
        <template>
          {{ subsMessage }} {{ $t('For further queries contact') }}
          <a class="first-link" href="https://support@enerman.in"
            >sales@enerman.in</a
          >
        </template>
      </Banner>
      <!-- TODO set state in v-if as computed property -->
      <v-container grid-list-md fluid pa-1 mt-1 v-if="isRouterView">
        <v-layout column>
          <v-flex style="flex-grow: 0" v-show="isDashboard($route.path)">
            <DashboardSelection
              :items="getDashboardList"
              selection="0"
            ></DashboardSelection>
          </v-flex>
          <v-flex grow>
            <router-view class="full-content-area" />
          </v-flex>
        </v-layout>
      </v-container>
      <HomeBanner v-else />
    </v-content>
    <DownloadListSnackBar></DownloadListSnackBar>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import moment from "moment";
const momentTz = require('moment-timezone');

import Login from "@/services/login";
import { EventBus } from "@/services/event-bus";
import Navigation from "@/components/container/Navigation";
import MainToolbar from "@/components/container/Toolbar";
const ScrollingBanner = () => import("@/components/common/ScrollingBanner");

const Banner = () => import("@/components/Banner");
const HomeBanner = () => import("@/components/home/HomeBanner");
const DashboardSelection = () =>
  import("@/components/common/DashboardSelection");
const DownloadListSnackBar = () =>
  import("@/components/container/DownloadListSnackBar");

export default {
  components: {
    Banner,
    HomeBanner,
    DashboardSelection,
    Navigation,
    MainToolbar,
    DownloadListSnackBar,
    ScrollingBanner,
  },
  data: () => ({
    isBannerOpen: true,
    showMap: false,
    plant: "",
  }),
  computed: {
    ...mapGetters([
      "hasPlantAssigned",
      "getPlantList",
      "getPlantInfo",
      "isRenewExceeded",
      "getUserInfo",
      "getSelectedPlantId",
      "getFloatingButton",
      "getBanner",
      "getGeneralState",
      "getUserInfo",
      "getActivePlantInfo",
      "getRules",
      "getTotalPlantCount",
      "isDashboard",
      "getDashboardList",
    ]),
    userName() {
      return this.getUserInfo("userName");
    },
    lastRouteSegment() {
      const path = this.$route.path;
      // Get the last part of the path
      return path.split("/").slice(-1)[0];
    },
    showGlobalBanner() {
        if (this.getRules('rule')) {
          const compConfig = this.getRules('rule').comp_config
          return Object.keys(compConfig).length && compConfig.global_banner && Object.keys(compConfig.global_banner.options).length > 0 && compConfig.global_banner.options.state
        }
        return false
      },
      globalBannerMsg() {
        if (this.getRules('rule')) {
          const compConfig = this.getRules('rule').comp_config
          return this.showGlobalBanner ? compConfig.global_banner.options.message : ''
        }
        return ''
      },
    bannerMsg() {
      const toPath = this.lastRouteSegment;
      if (this.getRules("rule")) {
        const accessRule = this.getRules("rule").comp_config;
        const comp = Object.keys(accessRule).find((el) => {
          return (
            accessRule[el].options &&
            accessRule[el].options.banner &&
            accessRule[el].options.banner.path === `/${toPath}`
          );
        });
        return comp ? this.getBanner(comp).message || "" : "";
      }
      return "";
    },
    showBanner() {
      return this.bannerMsg && this.bannerMsg.trim() !== "";
    },
    isRouterView() {
      const routerpathArr = this.$route.path.split("/");
      const role = this.getGeneralState("userData")["role"];

      return (
        !this.isRenewExceeded(this.getSelectedPlantId) ||
        this.$route.name === "home" ||
        ((role === "admin" || role === "super-admin") &&
          routerpathArr.length > 2 &&
          (routerpathArr[1] === "ics-admin" || routerpathArr[1] === "admin"))
      );
    },
    computeBannerShow() {
      return (
        this.isBannerOpen &&
        this.plantListExpiry &&
        this.$route.path === "/home"
      );
    },
    plantListExpiry() {
      return this.datesCheck("expiry_date") > 0;
    },
    subsMessage() {
      let isExpired = this.datesCheck("expiry_date");

      let key, defMsg;
      switch (isExpired) {
        case 4:
          key = "all_expired";
          defMsg = "Your plant Subscription have expired.";
          break;
        case 3:
          key = "expired";
          defMsg = "The Subscription for some plant has expired.";
          break;
        case 2:
        case 1:
          key = "before_renew";
          defMsg = "The Subscription for some plants will expire soon.";
          break;
        default:
          break;
      }

      return this.computeBannerMessage(key, defMsg);
    },
  },
  created() {
    if (!this.$session.exists() && !this.hasPlantAssigned) {
      this.logout();
    }
  },
  mounted() {
     // Example of handling missing translations in a specific language
    const missingHandler = (locale, key, vm) => {
      // Return the original text provided in $t() as fallback
      return key;
    };

    // Set up the missing translation handler
    this.$i18n.missing = missingHandler;

    // Set up a custom fallback handler for missing translations
    this.$i18n.fallbackHandler = (missingKey, locale, format, values) => {
      // Return the missing key as the fallback value
      return missingKey;
    };
    try {
      if (!this.getSelectedPlantId) {
        let activePlant = this.getPlantList[0];
        this.plant = activePlant.name;
        this.SET_SELECTED_PLANT_ID(activePlant.id);
      } else {
        this.plant = this.getActivePlantInfo("plant_name");
      }
    } catch (err) {
      return this.logout();
    }
    EventBus.$on("plantChanged", this.plantChange);
    /* Agathsya code starts here */
    if (window.innerWidth < 960) {
      $(".v-list__tile").click(function () {
        $(".v-toolbar__side-icon").trigger("click");
      });
    }

    // TODO: this might be causing memory leak
    this.$mqtt.on("message", (topic, message) => {
      const parsedMessage = JSON.parse(message.toString());
      const [, , plantId] = topic.split("/");
      let list = this.getPlantList.map((el) => el.id);
      if (topic.startsWith("/notification/") && list.indexOf(plantId) >= 0) {
        this.appendNotification(parsedMessage);
      }
    });
    this.notificationSubscriber();

    /* Agathsya code ends here */
  },

  beforeUnmount() {
    this.getPlantList.map((el) => {
      this.$mqtt.unsubscribe("/notification/" + el.id);
    });
  },
  methods: {
    ...mapActions(["resetState", "appendNotification"]),
    ...mapMutations(["SET_SELECTED_PLANT_ID"]),
    toggleBanner(val) {
      this.isBannerOpen = val;
    },
    async logout() {
      try {
        const payload = {
          token: this.getGeneralState("token"),
        };
        await Login.logoutUser(payload);
      } catch (err) {
        console.log(err, "ERROR ERROR ERROR");
      }
      this.$session.destroy();
      this.resetState();
      this.$router.push({
        name: "login",
      });
    },
    datesCheck() {
      if (
        this.getTotalPlantCount ==
        this.getGeneralState("totalExpiredPlantCount")
      ) {
        return 4;
      } else if (this.getGeneralState("totalExpiredPlantCount")) {
        return 3;
      } else if (this.getGeneralState("totalRenewPlantCount")) {
        return 2;
      } else if (this.getGeneralState("aboutToExpireCount")) {
        return 1;
      } else {
        return 0;
      }
    },
    computeBannerMessage(key, defMsg) {
      return this.getUserInfo("banner_messages") &&
        this.getUserInfo("banner_messages").home &&
        this.getUserInfo("banner_messages").home[key]
        ? this.getUserInfo("banner_messages").home[key]
        : defMsg;
    },
    notificationSubscriber() {
      this.getPlantList.map((el) => {
        this.$mqtt.subscribe(`/notification/${el.id}`);
      });
    },
    plantChange: function (plantId) {
      if (!plantId || plantId === "") {
        return;
      }
      this.SET_SELECTED_PLANT_ID(plantId);
    },
  },
  watch: {
    getSelectedPlantId(val) {
      if (val == undefined) {
        return
      }
      this.plant = this.getActivePlantInfo("plant_name");
      const selectedComponent = this.getGeneralState("selectedComponent");

      if (
        moment(
          this.getPlantInfo("renew_date", val)
        ).isAfter(momentTz().tz(this.getActivePlantInfo('timezone')))
      ) {
        let path = this.getRules("rule")
          ? this.getRules("rule").access_config[selectedComponent].path
          : "/";

        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="stylus">
@require '~vuetify/src/stylus/settings/_theme';
@import url('https://fonts.googleapis.com/css?family=Lato');

$material-dark.background = '#FF0000';

.content-height {
  height: calc(100% - 40px);
  max-height: calc(100% - 40px);
}

@media (max-width: 960px) {
  .v-content {
    padding: 65px 0px 0px !important;
  }

  .nav-color, .theme--dark .container.fluid, .theme--dark .legend-background {
    background-color: #fff !important;
  }

  .theme--dark .subscription-card {
    color: #2f3640;
  }
}

.subscription-card {
  padding-left: 10px !important;
}
</style>

<style scoped>
.content-style {
  max-height: 100vh;
  overflow-y: auto;
}

.full-content-area {
  height: 100%;
  width: 100%;
}

.first-link {
  color: #534b00 !important;
  text-decoration-line: underline;
}

.second-link {
  color: #485bff;
  cursor: pointer;
}

.last-update-mini {
  position: absolute;
  left: 0;
  bottom: 16px;
  text-align: center;
  margin-left: -8px;
}

.last-update {
  position: absolute;
  text-align: center;
  width: 100%;
}
</style>

<style>
/* Agathsya code ends here */
.scroll-overflow .v-table__overflow::-webkit-scrollbar {
  height: 6px;
  /* width: 50%; */
}

.scroll-overflow {
  overflow-y: scroll;
  scrollbar-color: #ff7347 #f5f5f5;
  scrollbar-width: thin;
}

.scroll-overflow .v-table__overflow::-webkit-scrollbar-thumb {
  background-color: #ff7347;
  /* background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent); */
}
</style>
